import React from 'react'

const STATUS_STYLES = {
  revisado: {
    bg: 'bg-green-100',
    text: 'text-green-800',
    label: 'Revisado'
  },
  inserido: {
    bg: 'bg-blue-100',
    text: 'text-blue-800',
    label: 'Inserido'
  },
  pendente: {
    bg: 'bg-yellow-100',
    text: 'text-yellow-800',
    label: 'Pendente'
  }
}

export default function StatusBadge({ status, className = '' }) {
  const style = STATUS_STYLES[status] || STATUS_STYLES.pendente

  return (
    <span
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${style.bg} ${style.text} ${className}`}
    >
      {style.label}
    </span>
  )
}
